import tabs from './tabs.constants';
import * as preferences from 'app/models/Preferences';
import { USER_TYPES } from 'app/common/constants/user.constants';

/**
 * Routes
 */

let routes = [
    {
        url: '/welcome',
        tabNameKey: tabs.LANDING,
        tabName: tabs.LANDING,
        parentTabName: tabs.LANDING,
        isMainPath: true
    },
    {
        url: '/dashboard/:dashboardId(\\d+)?',
        tabNameKey: tabs.DASHBOARD,
        tabName: tabs.DASHBOARD,
        parentTabName: tabs.DASHBOARD,
        isMainPath: true
    },
    {
        url: '/search',
        tabNameKey: tabs.SEARCH,
        tabName: tabs.SEARCH,
        parentTabName: tabs.SEARCH,
        isMainPath: true,
        relatedRoutes: [
            tabs.VIEW_SEARCH,
            tabs.TEMPLATE,
            tabs.TAG_UPDATES,
            tabs.COMMENTS,
            tabs.SEARCH_INSIGHTS,
            tabs.UNSAVED_SEARCH_INSIGHTS
        ]
    },
    {
        url: '/search/view-search/:feedId(\\d+)/insights',
        tabNameKey: tabs.SEARCH_INSIGHTS,
        tabName: tabs.SEARCH,
        parentTabName: tabs.SEARCH,
        isMainPath: false,
        noTabRendered: true
    },
    {
        url: '/search/view-search/:feedId(\\d+)',
        tabNameKey: tabs.VIEW_SEARCH,
        tabName: tabs.SEARCH,
        parentTabName: tabs.SEARCH,
        isMainPath: false,
        noTabRendered: true,
        isExact: true
    },
    {
        url: '/search/insights',
        tabNameKey: tabs.UNSAVED_SEARCH_INSIGHTS,
        tabName: tabs.SEARCH,
        parentTabName: tabs.SEARCH,
        isMainPath: false,
        noTabRendered: true
    },
    {
        url: '/search/template',
        tabNameKey: tabs.TEMPLATE,
        tabName: tabs.SEARCH,
        parentTabName: tabs.SEARCH,
        isMainPath: false,
        noTabRendered: true
    },
    {
        url: '/search/tag-updates',
        tabNameKey: tabs.TAG_UPDATES,
        tabName: tabs.SEARCH,
        parentTabName: tabs.SEARCH,
        isMainPath: false,
        noTabRendered: true
    },
    {
        url: '/search/comments',
        tabNameKey: tabs.COMMENTS,
        tabName: tabs.SEARCH,
        parentTabName: tabs.SEARCH,
        isMainPath: false,
        noTabRendered: true
    },
    {
        url: '/search/manage-sources/:sourceType(news|blogs-and-forums|email-subscriptions|rss|twitter)?',
        tabNameKey: tabs.MANAGE_SOURCES,
        tabName: tabs.MANAGE_SOURCES,
        parentTabName: tabs.SEARCH,
        isMainPath: false
    },
    {
        url: '/search/source-lists/:sourceListId(\\d+)?',
        tabNameKey: tabs.SOURCE_LIST,
        tabName: tabs.SOURCE_LIST,
        parentTabName: tabs.SEARCH,
        isMainPath: false,
        isExact: true
    },
    {
        url: '/search/archive',
        tabNameKey: tabs.ARCHIVE,
        tabName: tabs.ARCHIVE,
        parentTabName: tabs.SEARCH,
        isMainPath: false,
        requiredPreferences: [preferences.ENABLE_ARCHIVE_TAB]
    },
    {
        url: '/analyze',
        tabNameKey: tabs.ANALYZE,
        tabName: tabs.ANALYZE,
        isMainPath: true,
        requiredPreferences: [preferences.ENABLE_ANALYZE_TAB],
        allowedUserTypes: [USER_TYPES.ADMIN, USER_TYPES.STANDARD]
    },
    {
        url: '/analyze/create-analysis/:subView(select-charts|select-searches)?',
        tabNameKey: tabs.CREATE_ANALYSIS,
        tabName: tabs.CREATE_ANALYSIS,
        parentTabName: tabs.ANALYZE,
        isMainPath: false,
        requiredPreferences: [preferences.ENABLE_ANALYZE_TAB],
        allowedUserTypes: [USER_TYPES.ADMIN, USER_TYPES.STANDARD],
        relatedRoutes: [tabs.EDIT_ANALYSIS],
        subViews: { selectCharts: 'select-charts', selectSearches: 'select-searches' }
    },
    {
        url: '/analyze/edit-analysis/:analysisId/view-chart/:chartId',
        tabNameKey: tabs.VIEW_CHART,
        tabName: tabs.CREATE_ANALYSIS,
        parentTabName: tabs.ANALYZE,
        isMainPath: false,
        requiredPreferences: [preferences.ENABLE_ANALYZE_TAB],
        allowedUserTypes: [USER_TYPES.ADMIN, USER_TYPES.STANDARD],
        noTabRendered: true
    },
    {
        url: '/analyze/edit-analysis/:analysisId(\\d+)?/:subView(select-charts|select-searches)?',
        tabNameKey: tabs.EDIT_ANALYSIS,
        tabName: tabs.CREATE_ANALYSIS,
        parentTabName: tabs.ANALYZE,
        isMainPath: false,
        requiredPreferences: [preferences.ENABLE_ANALYZE_TAB],
        allowedUserTypes: [USER_TYPES.ADMIN, USER_TYPES.STANDARD],
        noTabRendered: true,
        subViews: { selectCharts: 'select-charts', selectSearches: 'select-searches' }
    },
    {
        url: '/analyze/saved-analysis',
        tabNameKey: tabs.SAVED_ANALYSIS,
        tabName: tabs.SAVED_ANALYSIS,
        parentTabName: tabs.ANALYZE,
        isMainPath: false,
        requiredPreferences: [preferences.ENABLE_ANALYZE_TAB],
        allowedUserTypes: [USER_TYPES.ADMIN, USER_TYPES.STANDARD]
    },
    {
        url: '/share',
        tabNameKey: tabs.NEWSLETTERS,
        tabName: tabs.NEWSLETTERS,
        parentTabName: tabs.SHARE,
        relatedRoutes: [
            tabs.CREATE_NEWSLETTER,
            tabs.EDIT_NEWSLETTER,
            tabs.CUSTOMIZE_NEWSLETTER,
            tabs.CUSTOMIZE_NEW_NEWSLETTER
        ],
        isMainPath: true,
        isExact: true,
        allowedUserTypes: [USER_TYPES.ADMIN, USER_TYPES.STANDARD]
    },
    {
        url: '/share/create-newsletter',
        tabNameKey: tabs.CREATE_NEWSLETTER,
        tabName: tabs.NEWSLETTERS,
        parentTabName: tabs.SHARE,
        isMainPath: false,
        isExact: true,
        noTabRendered: true,
        allowedUserTypes: [USER_TYPES.ADMIN, USER_TYPES.STANDARD]
    },
    {
        url: '/share/edit-newsletter/:alertId(\\d+)',
        tabNameKey: tabs.EDIT_NEWSLETTER,
        tabName: tabs.NEWSLETTERS,
        parentTabName: tabs.SHARE,
        isMainPath: false,
        isExact: true,
        noTabRendered: true,
        allowedUserTypes: [USER_TYPES.ADMIN, USER_TYPES.STANDARD]
    },
    {
        url: '/share/edit-newsletter/:alertId(\\d+)/customize',
        tabNameKey: tabs.CUSTOMIZE_NEWSLETTER,
        tabName: tabs.NEWSLETTERS,
        parentTabName: tabs.NEWSLETTERS,
        isMainPath: false,
        noTabRendered: true,
        allowedUserTypes: [USER_TYPES.ADMIN, USER_TYPES.STANDARD]
    },
    {
        url: '/share/create-newsletter/customize',
        tabNameKey: tabs.CUSTOMIZE_NEW_NEWSLETTER,
        tabName: tabs.NEWSLETTERS,
        parentTabName: tabs.SHARE,
        isMainPath: false,
        noTabRendered: true,
        allowedUserTypes: [USER_TYPES.ADMIN, USER_TYPES.STANDARD]
    },
    {
        url: '/share/user-manager',
        tabNameKey: tabs.EMAIL_USER_MANAGER,
        tabName: tabs.EMAIL_USER_MANAGER,
        parentTabName: tabs.SHARE,
        isMainPath: false,
        requiredPreferences: [preferences.ENABLE_USER_MANAGER],
        allowedUserTypes: [USER_TYPES.ADMIN, USER_TYPES.STANDARD]
    },
    {
        url: '/share/email-themes',
        tabNameKey: tabs.EMAIL_THEMES,
        tabName: tabs.EMAIL_THEMES,
        parentTabName: tabs.SHARE,
        isMainPath: false,
        requiredPreferences: [preferences.SHOW_EMAIL_THEMES_SUBTAB],
        allowedUserTypes: [USER_TYPES.ADMIN, USER_TYPES.STANDARD]
    },
    {
        url: '/share/export',
        tabNameKey: tabs.EXPORT,
        tabName: tabs.EXPORT,
        parentTabName: tabs.SHARE,
        isMainPath: false,
        requiredPreferences: [preferences.SHOW_EXPORT_TAB],
        allowedUserTypes: [USER_TYPES.ADMIN, USER_TYPES.STANDARD]
    },
    {
        url: '/newsletter-subscriptions',
        tabNameKey: tabs.NEWSLETTER_SUBSCRIPTIONS,
        tabName: tabs.NEWSLETTER_SUBSCRIPTIONS,
        parentTabName: tabs.NEWSLETTER_SUBSCRIPTIONS,
        isMainPath: true,
        allowedUserTypes: [USER_TYPES.NEWSDESK_DIRECT]
    }
];

let byKey = routes.reduce((state, route) => {
    state[route.tabNameKey] = route;
    return state;
}, {});

export const array = routes;
export { byKey };
